import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/** Clears the in-memory selection when the collection context changes. */
export const clearSelectionOnContextChange = store.effects.create(
  <TTypeParams extends Plugin.TypeParams>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    plugin.collection.feature.actions.changeContext
      .observe()
      .pipe(
        rxjs.map(action =>
          feature.actions.resetSelections.request.from(action).create(),
        ),
      ),
)
